import _request from './request.js';

/**
 * 闪兑API接口
 */
export default {
	/**
	 * 获取支持的兑换对
	 * GET /api/flashswap/pairs
	 */
	async getPairs() {
		try {
			console.log('调用闪兑API: getPairs');
			const result = await _request.request('api/flashswap/pairs', {}, 'GET');
			console.log('getPairs API响应:', result);
			return result;
		} catch (error) {
			console.error('getPairs API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 获取闪兑报价
	 * POST /api/flashswap/quote
	 * @param {Object} data - 请求数据
	 * @param {string} data.from_currency - 支付币种
	 * @param {string} data.to_currency - 获得币种
	 * @param {string|number} data.amount - 支付金额
	 */
	async getQuote(data) {
		try {
			console.log('调用闪兑API: getQuote, 参数:', data);
			const result = await _request.request('api/flashswap/quote', data, 'POST');
			console.log('getQuote API响应:', result);
			return result;
		} catch (error) {
			console.error('getQuote API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 执行闪兑操作
	 * POST /api/flashswap/swap
	 * @param {Object} data - 请求数据
	 * @param {string} data.from_currency - 支付币种
	 * @param {string} data.to_currency - 获得币种
	 * @param {string|number} data.amount - 支付金额
	 */
	async executeSwap(data) {
		try {
			console.log('调用闪兑API: executeSwap, 参数:', data);
			const result = await _request.request('api/flashswap/swap', data, 'POST');
			console.log('executeSwap API响应:', result);
			return result;
		} catch (error) {
			console.error('executeSwap API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 获取用户订单列表
	 * GET /api/flashswap/orders
	 */
	async getOrders() {
		try {
			console.log('调用闪兑API: getOrders');
			const result = await _request.request('api/flashswap/orders', {}, 'GET');
			console.log('getOrders API响应:', result);
			return result;
		} catch (error) {
			console.error('getOrders API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 获取订单详情
	 * GET /api/flashswap/order/{id}
	 * @param {string|number} orderId - 订单ID
	 */
	async getOrderDetail(orderId) {
		try {
			console.log('调用闪兑API: getOrderDetail, 订单ID:', orderId);
			const result = await _request.request(`api/flashswap/order/${orderId}`, {}, 'GET');
			console.log('getOrderDetail API响应:', result);
			return result;
		} catch (error) {
			console.error('getOrderDetail API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 获取手续费信息
	 * GET /api/flashswap/fees
	 */
	async getFees() {
		try {
			console.log('调用闪兑API: getFees');
			const result = await _request.request('api/flashswap/fees', {}, 'GET');
			console.log('getFees API响应:', result);
			return result;
		} catch (error) {
			console.error('getFees API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 获取用户余额
	 * GET /api/flashswap/balances
	 */
	async getBalances() {
		try {
			console.log('调用闪兑API: getBalances');
			const result = await _request.request('api/flashswap/balances', {}, 'GET');
			console.log('getBalances API响应:', result);
			return result;
		} catch (error) {
			console.error('getBalances API调用失败:', error);
			throw error;
		}
	},

	/**
	 * 获取支持的币种列表（兼容方法）
	 */
	async getSupportedCurrencies() {
		try {
			console.log('调用闪兑API: getSupportedCurrencies (兼容方法)');
			// 通过获取交易对来获取支持的币种
			const pairsResult = await this.getPairs();
			if (pairsResult && pairsResult.code === 200 && pairsResult.data) {
				// 从交易对中提取币种信息
				const currencies = new Set();
				pairsResult.data.forEach(pair => {
					if (pair.from_currency?.symbol) {
						currencies.add(pair.from_currency.symbol);
					}
					if (pair.to_currency?.symbol) {
						currencies.add(pair.to_currency.symbol);
					}
				});
				
				return {
					code: 200,
					data: Array.from(currencies).map(symbol => ({ symbol }))
				};
			}
			return pairsResult;
		} catch (error) {
			console.error('getSupportedCurrencies API调用失败:', error);
			throw error;
		}
	}
}
